var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 446 446",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.742,188.796c7.7,4.466 12.454,12.721 12.454,21.625c-0,8.9 -4.754,17.154 -12.454,21.621l-158.525,92c-3.813,2.212 -8.142,3.379 -12.55,3.379c-13.713,-0 -25,-11.288 -25,-25l-0,-184.009c-0,-13.712 11.287,-25 25,-25c4.408,0 8.737,1.167 12.55,3.38l158.525,92.004Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.029,210.417c0.042,-7.425 -3.929,-14.325 -10.375,-18.017l-158.529,-92.004c-3.175,-1.846 -6.783,-2.817 -10.458,-2.817c-11.43,0 -20.834,9.404 -20.834,20.833l0,184.009c0,11.429 9.404,20.833 20.834,20.833c3.675,0 7.283,-0.971 10.458,-2.817l158.525,-92.004c6.446,-3.691 10.421,-10.587 10.379,-18.016m4.167,-0c0.05,8.912 -4.717,17.187 -12.45,21.62l-158.529,92.005c-3.813,2.212 -8.142,3.379 -12.55,3.379c-13.713,-0 -25,-11.288 -25,-25l-0,-184.009c-0,-13.712 11.287,-25 25,-25c4.408,0 8.737,1.167 12.55,3.38l158.525,92.004c7.733,4.429 12.5,12.708 12.454,21.621Z",
    style: {
      fill: "#707070",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOnly);
export default __webpack_public_path__ + "static/media/play-only.d2eb3089c7998efca8f432d4e73b70fc.svg";
export { ForwardRef as ReactComponent };